/* eslint-disable @typescript-eslint/no-unused-vars */
import createActions from '../config/actions/createActions';
import { action } from '@play-co/replicant';
import { match2TournamentCheats } from './tournament/match2-tournament.cheats';
import { match2DailyChallengeCheats } from './dailychallenge/match2-dailychallenge.cheats';
import { match2ShopBundlesCheats } from './shopbundles/match2-shopbundles.cheats';
import { match2BundleSaleCheats } from './bundlesale/match2-bundlesale.cheats';
import { match2MagicLampsCheats } from './magiclamps/magiclamps.cheats';
import { match2StreakBattleRoyaleCheats } from '../streakbattleroyale/streakbattleroyale.cheats';
import { cardsCheats } from '../cards/cards.cheats';
import { superLollipopCheats } from '../superLollipop/superLollipop.cheats';
import { weeklyLeaderboardCheats } from '../weeklyLeaderboard/weeklyLeaderboard.cheats';
import { treasureExpressCheats } from '../treasureExpress/treasureExpress.cheats';
import { championsLeagueCheats } from '../championsLeague/championsLeague.cheats';
import { rescueLevelCheats } from '../rescueLevel/rescueLevel.cheats';
import { resetBuruStreak } from './match2.modifiers';
import { dreamDriftCheats } from '../dreamDrift/dreamDrift.cheats';

/**
 * Cheat actions for Match2. This is for development mode only, not allowed in production.
 * Cheats from match2 sub-features like tournaments should be in their own files, but added here,
 * so that is guaranteed that they will exist in development mode only.
 */
const match2MiscCheats = createActions({
  /**
   * Clear all match2 tips - the game will show them again if suitable
   */
  cheat_resetMatch2Tips: action((state, args: void, _api) => {
    state.match2.tips = {};
  }),
  /**
   * Set buru win streak to 3
   */
  cheat_buruStreakMax: action((state, args: void, _api) => {
    state.match2.buruStreak.value = 3;
  }),
  /**
   * Reset buru win streak to 0
   */
  cheat_buruStreakReset: action((state, args: void, _api) => {
    resetBuruStreak(state);
  }),

  /**
   * Reset daily bonus
   */
  cheat_resetDailyBonus: action((state, args: void, _api) => {
    state.match2.dailyBonus.nextBonusTimestamp = 0;
    state.match2.dailyBonus.nextBonusTimestamp = 0;
    state.match2.dailyBonus.dailyCount = 0;
    state.match2.dailyBonus.totalCount = 0;
    state.match2.dailyBonus.currentDayStamp = 0;
  }),
});

export const match2Cheats = {
  ...match2MiscCheats,
  ...match2TournamentCheats,
  ...match2DailyChallengeCheats,
  ...match2ShopBundlesCheats,
  ...match2BundleSaleCheats,
  ...match2MagicLampsCheats,
  ...match2StreakBattleRoyaleCheats,
  ...cardsCheats,
  ...superLollipopCheats,
  ...weeklyLeaderboardCheats,
  ...treasureExpressCheats,
  ...championsLeagueCheats,
  ...rescueLevelCheats,
  ...dreamDriftCheats,
};
